export { default as EZKLProcessor } from './ezkl/processor/index.js';
export { default as FflonkProcessor } from './fflonk/processor/index.js';
export { default as Groth16Processor } from './groth16/processor/index.js';
export { default as Risc0Processor } from './risc0/processor/index.js';
export { default as UltraPlonkProcessor } from './ultraplonk/processor/index.js';
export { default as Plonky2Processor } from './plonky2/processor/index.js';
export { default as SP1Processor } from './sp1/processor/index.js';
export { default as UltraHonkProcessor } from './ultrahonk/processor/index.js';
export { default as TEEProcessor } from './tee/processor/index.js';
// ADD_NEW_PROOF_TYPE
